import { render, staticRenderFns } from "./QuotationsList.vue?vue&type=template&id=13b0612a&scoped=true"
import script from "./QuotationsList.vue?vue&type=script&lang=js"
export * from "./QuotationsList.vue?vue&type=script&lang=js"
import style0 from "./QuotationsList.vue?vue&type=style&index=0&id=13b0612a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b0612a",
  null
  
)

export default component.exports